export default {
    topics: {
        getList: ['GET', '/topics'],
        getOne: ['GET', '/topics/{id}'],
        getStatistic: ['GET', '/topics/statistic'],
        update: ['PUT', '/topics/{id}'],
        unread: ['PUT', '/topics/{id}/unread'],
    },
};
